// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1gsOH","disabled":"FileBtn_disabled___QVIP","warn":"FileBtn_warn__8aG1s","fade":"FileBtn_fade__1GuHZ"};